// extracted by mini-css-extract-plugin
export var activeDot = "_2s-c";
export var buttonContainer = "_2s-9";
export var channelButton = "_2s-a";
export var clickable = "_2s-d";
export var content = "_2s-0";
export var contentFull = "_2s-2";
export var contentThird = "_2s-1";
export var contentWrapper = "_2s-7";
export var description = "_2s-5";
export var heightShort = "_2s-f";
export var image = "_2s-3";
export var imageContainer = "_2s-4";
export var selectButton = "_2s-e";
export var spinnerContainer = "_2s-b";
export var titleContent = "_2s-8";
export var titleWrapper = "_2s-6";